module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/LockClosedOutline.00035d49.svg";